// "capsens-suitability-questionnaire/app/assets/javascripts/capsens/suitability_questionnaire/application.js" file
// cannot be imported as it use old sprockets syntax (//= require ...) that is not compatible with esbuild
// so we manually copy the content here and import all the steps manually.

// Define CSQ global object (from application.js)
window.CSQ = {}

window.CSQ.helpers = {
  getQueryStringParameter: (parameterName) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(parameterName);
  },

  clearInputField: (inputElement) => {
    if (inputElement.type === 'radio' || inputElement.type === 'checkbox') {
      inputElement.checked = false;
    } else {
      inputElement.value = null;
    }
  }
}

// Import all files from steps directory
import 'capsens-suitability-questionnaire/app/assets/javascripts/capsens/suitability_questionnaire/steps/knowledge';
import 'capsens-suitability-questionnaire/app/assets/javascripts/capsens/suitability_questionnaire/steps/modal';
import 'capsens-suitability-questionnaire/app/assets/javascripts/capsens/suitability_questionnaire/steps/objectives_and_financial_situation';
import 'capsens-suitability-questionnaire/app/assets/javascripts/capsens/suitability_questionnaire/steps/step_dropdown';
